import { IConnection } from "./connection";

interface IPoolConnection {
  id: string;
  connection: IConnection;
}

export class ConnectionPool {
  private connectionPool: IPoolConnection[] = [];

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  add(id: string, connection: IConnection) {
    this.connectionPool.push({ id, connection });
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  remove(connectionId: string) {
    this.connectionPool = this.connectionPool.filter(c => c.connection.connectionId !== connectionId);
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get(id: string) {
    // Due to multiple instances of iframes per widget we need
    // to take the last one. This is a hack and will require
    // refactor to provide one iframe per widget.
    const conn = this.connectionPool.filter(c => c.id === id).pop();
    if (!conn) {
      return null;
    }

    return conn.connection;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getByConnectionId(id: string) {
    const [conn] = this.connectionPool.filter(c => c.connection.connectionId === id);
    if (!conn) {
      return null;
    }

    return conn.connection;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getAll() {
    return this.connectionPool;
  }
}

export default new ConnectionPool();
